import { ALLOWED_EXTENSIONS } from '../constants/FileUploadConstants';

export const validateFileFormat = (
  file: File,
  t: (key: string, options?: any) => string
): { isValid: boolean; error?: string } => {
  // Check file extension
  const fileName = file.name.toLowerCase();
  const hasValidExtension = ALLOWED_EXTENSIONS.some((ext) =>
    fileName.endsWith(ext)
  );

  if (!hasValidExtension) {
    return {
      isValid: false,
      error: t('file-format-invalid-extension-message', {
        extensions: ALLOWED_EXTENSIONS.join(', '),
      }),
    };
  }

  return { isValid: true };
};
